import React from 'react';
import { SwitchLabel, SwitchInput, SwitchWrapper } from './styles'

const DefaultToggle = ({ label, checked, onChange, disabled = false }) => {
  return (
    <SwitchWrapper $disabled={disabled}>
      <SwitchLabel>{label}</SwitchLabel>
      <SwitchInput
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
    </SwitchWrapper>
  );
};

export default DefaultToggle;
